import type { ComponentProps } from 'react';
import React from 'react';
import { StyleSheet } from 'react-native';

import { theme } from '@garnish/constants';
import { DisplayText } from '@garnish/core';

import { ModalRow } from '../ModalRow';

import type { PaletteProps } from '../../Modal.types';

export const ModalHeadline = (props: ComponentProps<typeof DisplayText> & PaletteProps) => {
  const { children, palette, style, ...restProps } = props;

  const paletteSpecificTextStyles = palette
    ? // @ts-expect-error error TS7053: Element implicitly has an 'any' type becau
      paletteHeadingTextStyles[palette]
    : undefined;

  return (
    <ModalRow>
      <DisplayText
        sizeMatch={['24', '32']}
        style={[styles.textGap, style, paletteSpecificTextStyles]}
        {...restProps}
      >
        {children}
      </DisplayText>
    </ModalRow>
  );
};

// ─── Styles ────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  textGap: {
    marginBottom: theme.spacing['2'],
  },
  headlineSecondary: {
    color: theme.colors.WHITE,
  },
});

// ─── Palette Styles ────────────────────────────────────────────────────

const paletteHeadingTextStyles = {
  primary: undefined,
  neutral: undefined,
  secondary: styles.headlineSecondary,
  lime: styles.headlineSecondary,
};
